import React from "react"
import { context } from "../index.js"
import { observer } from "mobx-react-lite";
import { CircularProgress } from "@mui/material"
import Questionnaire from "./questionnaire/Questionnaire.tsx"
import { useParams } from "react-router-dom"
import Header from "./Header.tsx";
import LoginPage from "./LoginPage.tsx";
import { format } from "date-fns";
import RedirectPage from "./RedirectPage.tsx";
import { getCookie, removeCookie } from "../misc/utils.ts";


export default observer(function App() {

	var params = useParams()
	const { questionnaire, setToken } = context

	React.useEffect(() => {
		// One-time-link login flow
		var tokenToSet = getCookie("set_token")
		
		if (tokenToSet) {
			setToken(tokenToSet)
			removeCookie("set_token")
		}
        
		if (!questionnaire && params.questionnaireUid) {
            context.loadQuestionnaire(params.questionnaireUid)
        }
    })

	return (
		<div className={context.embedded ? "app embedded" : "app"}>
			{!context.embedded ? (
				<>
					<div style={{width: "100vw", position: "fixed", zIndex: 1000}}>
						<Header />
					</div>

					{/* The first header is fixed and will resize its height dynamically, 
					so to avoid it expanding over the page content, we add this non-fixed
					header to push the page content away from the header without being seen. */}
					<div style={{width: "100vw", pointerEvents: "none"}}>
						<Header />
					</div>
				</>
			) : null}

			<main>
				<div className="main-inner">
					<AppBody />
				</div>
			</main>
		</div>
	)
})


const AppBody = observer(function () {

	const { questionnaire, answers, token, locked, redirectCountdown } = context

	if (!token && redirectCountdown != null) {
		return <RedirectPage />
	}
	
	if (!token) {
		return <LoginPage />
	}

    if (!questionnaire) {
		return <QuestionnaireLoading />
	}

	if (!locked) {
		return <Questionnaire key={answers?.submitted_pages} />
	}

	return <QuestionnaireLocked />
})


function QuestionnaireLoading () {
	return (
		<div style={{display: "grid", gap: "10px", margin: "auto", textAlign: "center"}}>
			<CircularProgress style={{width: "20px", height: "20px", margin: "auto"}} />
			<small>Loading Questionnaire...</small>
		</div>
	)
}


const QuestionnaireLocked = observer(function () {

	var updatedAt = new Date(context.questionnaire.updatedAt)
	var redirectUri = context.completionRedirectUri

	return (
		<div style={{maxWidth: "600px"}}>
			<h1>Questionnaire Complete</h1>
			<div className="help-text">at {format(updatedAt, "PPPP")} by {context.respondentEmail}</div>

			<p>This Questionnaire has been completed so you will no longer be able to view or edit any of the answers.</p>
			<p>If you would like to amend any answers, please contact you legal adviser so they can restore access for you.</p>

			{redirectUri ? (
				<>
					<p>To continue to the next stage of your application, click the link below.</p>
					<a href={redirectUri}>{redirectUri}</a>
				</>
			) : null}

			{context.redirectCountdown !== null && context.redirectCountdown > -1 ? (
				<div style={{display: "flex", gap: "10px", alignItems: "center"}}>
					<CircularProgress style={{width: "12px", height: "12px"}} color="secondary" />
					<p>Redirecting you in {context.redirectCountdown}.</p>
				</div>
			) : null}
		</div>
	)
})